














































































































import { Component,	Watch, Vue } from 'vue-property-decorator';
import AppHome from '@/views/Home.vue'
import AppQuestion from '@/views/Question.vue'
import AppResults from '@/views/Results.vue'

import { bus } from '@/main'

const onClickaway = require('vue-clickaway')
const draggable = require('vuedraggable')

@Component({
	directives: {
		onClickaway: onClickaway.directive
	},
	components: {
		draggable,
		AppHome,
		AppQuestion,
		AppResults
	}
})
export default class App extends Vue {
	appInitComplete: boolean = false
	privacyOpen: boolean = false
	privacyOpenedRecently: boolean = false
	privacyText: string = this.$store.getters.data.privacyText
	
	get indicatorWidth(): string {
		return `width: calc((100% / ${this.$store.getters.data.questions.length}) * ${this.$store.getters.currentScreen})`;
	}
	get userOnResultScreen(): boolean {
		return this.$store.getters.userOnResultScreen
	}
	get showNextButton(): boolean {
		if (this.$store.getters.visitedQuestions.indexOf(this.$store.getters.currentScreen) !== -1 && !this.userOnResultScreen) {
			return true
		}

		return false
	}

	@Watch('privacyOpen')
	onInfoOpenChange(): void {
		if (this.privacyOpen) {
			this.privacyOpenedRecently = true

			setTimeout(() => {
				this.privacyOpenedRecently = false
			}, 400)
		}
	}

	navigateToNext(): void {
		if (this.$store.getters.userChoices.length >= this.$store.getters.currentScreen && !this.userOnResultScreen) {
			if (this.$store.getters.data.questions.length === this.$store.getters.currentScreen) {
				this.$router.push({ name: 'results' })
			} else {
				this.$router.push({ name: 'question', params: { questionId: JSON.stringify(this.$store.getters.currentScreen + 1) } })
			}
		}
	}
	navigateToPrevious(): void {
		if (this.$store.getters.onAnswerScreen && !this.userOnResultScreen) {
			this.$router.push({ name: 'question', params: { questionId: JSON.stringify(this.$store.getters.currentScreen) } })
			return
		} else if (this.userOnResultScreen) {
			this.$store.dispatch('userOnResultScreen', false)
			this.$router.push({ name: 'question', params: { questionId: JSON.stringify(this.$store.getters.data.questions.length) } })
		} else {
			if ((this.$store.getters.currentScreen - 1) === 0) {
				this.$router.push('/')
			} else {
				this.$router.push({ name: 'question', params: { questionId: JSON.stringify(this.$store.getters.currentScreen - 1) } })
			}
		}
	}
	closePrivacyPanel(): void {
		if (!this.privacyOpenedRecently) {
			this.privacyOpen = false
		}
	}

	mounted() {
		this.appInitComplete = true

		bus.$on('togglePrivacyPanel', (state: boolean) => {
			this.privacyOpen = state
		})

		document.addEventListener('keydown', e => {
			if (e.keyCode === 27) {
				this.privacyOpen = false
			}
		})
	}
}
